export { autocapturePlugin as plugin, autocapturePlugin } from './autocapture-plugin';
export { frustrationPlugin } from './frustration-plugin';
export { WindowMessenger } from './libs/messenger';
//# sourceMappingURL=index.js.map